import React from 'react';
import { Box } from '@mui/material';

import { MobileCalendarHeader, MobileCalendarHeaderProps } from './MobileCalendarHeader';
import { MobileCalendarBody, MobileCalendarBodyProps } from './MobileCalendarBody';
import { MobileCalendarComponents } from './shared';


export type MobileCalendarViewProps = {
  today: string;

  date: MobileCalendarBodyProps['date'];
  setDate: MobileCalendarBodyProps['setDate'];
  currentMonth: MobileCalendarHeaderProps['currentMonth'];
  setCurrentMonth: MobileCalendarHeaderProps['setCurrentMonth'];

  headerLeftAddons?: MobileCalendarHeaderProps['leftAddons'];
  headerRightAddons?: MobileCalendarHeaderProps['rightAddons'];

  components?: MobileCalendarComponents;
};


export const MobileCalendarView: React.FC<MobileCalendarViewProps> = ({ today, date, setDate, currentMonth, setCurrentMonth, components, ...props }) => {
  const [ expanded, setExpanded ] = React.useState(() => {
    if (window.innerHeight < 600) {
      return false;
    }
    return true;
  });

  return (
    <Box width="100%">
      <MobileCalendarHeader
        today={today}
        date={date}
        setDate={setDate}
        currentMonth={currentMonth}
        setCurrentMonth={setCurrentMonth}

        expanded={expanded}
        onMonthTitleClick={() => setExpanded(!expanded)}

        leftAddons={props.headerLeftAddons}
        rightAddons={props.headerRightAddons}
      />
      <MobileCalendarBody
        today={today}
        date={date}
        setDate={setDate}
        currentMonth={currentMonth}
        setCurrentMonth={setCurrentMonth}
        components={components}
        expanded={expanded}
      />
    </Box>
  );
};
